module.exports = __webpack_public_path__ + "img/stance4.f518ff8e.png";